import React from 'react';
import ConfirmRenewalContractFormService from '../services/ConfirmRenewalContractFormService';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import ConfirmRenewalContractForm from './ConfirmRenewalContractForm';
import { BRAZIL } from '../../../core/consts';

class ConfirmRenewalContractFormContainer extends React.Component {
  static propTypes = {
    contractId: PropTypes.string,
  };

  componentDidMount() {
    ConfirmRenewalContractFormService.init(this.props.contractId);
  }

  handleReset() {
    ConfirmRenewalContractFormService.form.reset();
    ConfirmRenewalContractFormService.productsService.form.reset();
  }

  render() {
    return (
      <ConfirmRenewalContractForm
        onSubmit={ConfirmRenewalContractFormService.handleSubmit}
        onReset={this.handleReset}
        values={ConfirmRenewalContractFormService.form.getValues()}
        disabled={ConfirmRenewalContractFormService.submit.fetching || ConfirmRenewalContractFormService.fetch.fetching}
        loading={ConfirmRenewalContractFormService.fetch.fetching}
        onAddProduct={ConfirmRenewalContractFormService.productsService.handleToggleModal}
        onChange={ConfirmRenewalContractFormService.onChange}
        submitting={ConfirmRenewalContractFormService.submit.fetching}
        errors={ConfirmRenewalContractFormService.form.errors}
        currencyType={
          !ConfirmRenewalContractFormService.form.getValue('country') ||
          BRAZIL.includes(ConfirmRenewalContractFormService.form.getValue('country'))
            ? 'real'
            : 'dollar'
        }
      />
    );
  }
}

export default observer(ConfirmRenewalContractFormContainer);
